export default __webpack_public_path__ + "static/media/partner3.c0f73532.jpg";